import { Link } from "react-router-dom";
import { Brand } from "../components/Brand";

export function Landing() {
  return (
    <div className="auth-wrap">
      <div className="auth-card card">
        <Brand />
        <h1>Bem-vindo ao MM Money</h1>
        <p className="muted" style={{ marginTop: 0, marginBottom: 18 }}>
          Escolha o seu ambiente. Pessoa Física e Pessoa Jurídica têm acessos totalmente independentes.
        </p>
        <Link to="/pf/entrar" className="btn primary block" style={{ display: "block", textAlign: "center", textDecoration: "none", marginBottom: 10 }}>
          Entrar como Pessoa Física
        </Link>
        <Link to="/pj/entrar" className="btn ghost block" style={{ display: "block", textAlign: "center", textDecoration: "none" }}>
          Entrar como Pessoa Jurídica
        </Link>
      </div>
    </div>
  );
}
